import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractDialogService, canDismissWhenNotSwiped, DialogOptions } from '@examdojo/core/dialog';
import { ChallengeDialogContainerComponent } from './challenge-dialog-container.component';

export const CHALLENGE_DIALOG_ID = 'challenge-dialog';

@Injectable({ providedIn: 'root' })
export class ChallengeDialogService extends AbstractDialogService {
  readonly id = CHALLENGE_DIALOG_ID;
  readonly component = ChallengeDialogContainerComponent;

  override options: DialogOptions = {
    cssClass: 'modified-modal font-primary fullscreen',
    backdropDismiss: false,
    handle: false,
    breakpoints: undefined,
    initialBreakpoint: undefined,
    canDismiss: canDismissWhenNotSwiped,
  };

  readonly router = inject(Router);
}
